import { API_AUTH, API_AUTH_FILE } from "./common";

const xuatExcelApi = {
  kiemTraDuLieuCamDo: ({
    dateFrom,
    dateTo,
    code,
    customerName,
    address,
    noteTaiSan,
    status,
    debt,
    userName,
    pageIndex,
    pageSize,
    dongtungay,
    dongdenngay,
  }) =>
    API_AUTH.get(
      `xuatexcel/kiem-tra-du-lieu-cam-do?dateFrom=${dateFrom}&dateTo=${dateTo}&code=${code}&customerName=${customerName}&address=${address}
      &noteTaiSan=${noteTaiSan}&status=${status}&debt=${debt}&userName=${userName}&dongtungay=${dongtungay}&dongdenngay=${dongdenngay}`,
      {},
    ),

  dulieuCamDo: (
    dateFrom,
    dateTo,
    code,
    customerName,
    address,
    noteTaiSan,
    status,
    debt,
    userName,
    pageIndex,
    dongtungay,
    dongdenngay,
  ) =>
    API_AUTH.get(
      `xuatexcel/du-lieu-cam-do?dateFrom=${dateFrom}&dateTo=${dateTo}&code=${code}&customerName=${customerName}&address=${address}
          &noteTaiSan=${noteTaiSan}&status=${status}&debt=${debt}&userName=${userName}&dongtungay=${dongtungay}&dongdenngay=${dongdenngay}&count=${pageIndex}`,
      {},
    ),

  kiemTraDuLieuTinChap: ({
    dateFrom,
    dateTo,
    code,
    customerName,
    address,
    noteTaiSan,
    status,
    debt,
    userName,
    pageIndex,
    pageSize,
    taiSan = 0,
  }) =>
    API_AUTH.get(
      `xuatexcel/kiem-tra-du-lieu-tin-chap?dateFrom=${dateFrom}&dateTo=${dateTo}&code=${code}&customerName=${customerName}&address=${address}&noteTaiSan=${noteTaiSan}&status=${status}&debt=${debt}&userName=${userName}&taiSan=${taiSan}`,
      {},
    ),

  duLieuTinChap: (
    dateFrom,
    dateTo,
    code,
    customerName,
    address,
    noteTaiSan,
    status,
    debt,
    userName,
    pageIndex,
    taiSan = 0,
  ) =>
    API_AUTH.get(
      `xuatexcel/du-lieu-tin-chap?dateFrom=${dateFrom}&dateTo=${dateTo}&code=${code}&customerName=${customerName}&address=${address}&noteTaiSan=${noteTaiSan}&status=${status}&debt=${debt}&userName=${userName}&taiSan=${taiSan}&count=${pageIndex}`,
      {},
    ),

  kiemTraDuLieuTaiSan: ({
    tentaisan,
    tenkhachhang,
    kho,
    trangthai,
    tinhtrang,
    ghichu,
    pageIndex,
    pageSize,
  }) =>
    API_AUTH.get(
      `xuatexcel/kiem-tra-du-lieu-tai-san?tentaisan=${tentaisan}&tenkhachhang=${tenkhachhang}&kho=${kho}&trangthai=${trangthai}&tinhtrang=${tinhtrang}&ghichu=${ghichu}`,
      {},
    ),

  duLieuTaiSan: (
    tentaisan,
    tenkhachhang,
    kho,
    trangthai,
    tinhtrang,
    ghichu,
    pageIndex,
  ) =>
    API_AUTH.get(
      `xuatexcel/du-lieu-tai-san?tentaisan=${tentaisan}&tenkhachhang=${tenkhachhang}&kho=${kho}&trangthai=${trangthai}&tinhtrang=${tinhtrang}&ghichu=${ghichu}&count=${pageIndex}`,
      {},
    ),
  duLieuKySo: (sSearch, sLoaiHopDong, tuNgay, denNgay, sTrangThai) =>
    API_AUTH_FILE.get(
      `kyso/export?search=${encodeURIComponent(sSearch)}&loaiHopDong=${encodeURIComponent(sLoaiHopDong)}&tuNgay=${encodeURIComponent(tuNgay)}&denNgay=${encodeURIComponent(denNgay)}
      &trangThai=${encodeURIComponent(sTrangThai)}`,
      {},
      {
        responseType: "arraybuffer",
        transformResponse: [(data) => data],
      },
    ),

  kiemTraDuLieuTraGop: ({
    dateFrom,
    dateTo,
    code,
    customerName,
    address,
    noteTaiSan,
    status,
    debt,
    userName,
    pageIndex,
    pageSize,
    taiSan = 0,
    dongtungay,
    dongdenngay,
  }) =>
    API_AUTH.get(
      `xuatexcel/kiem-tra-du-lieu-tra-gop?dateFrom=${dateFrom}&dateTo=${dateTo}&code=${code}&customerName=${customerName}
            &address=${address}&noteTaiSan=${noteTaiSan}&status=${status}&debt=${debt}&userName=${userName}&taiSan=${taiSan}
            &dongtungay=${dongtungay}&dongdenngay=${dongdenngay}`,
      {},
    ),

  dulieuTraGop: (
    dateFrom,
    dateTo,
    code,
    customerName,
    address,
    noteTaiSan,
    status,
    debt,
    userName,
    pageIndex,
    taiSan = 0,
    dongtungay,
    dongdenngay,
  ) =>
    API_AUTH.get(
      `xuatexcel/du-lieu-tra-gop?dateFrom=${dateFrom}&dateTo=${dateTo}&code=${code}&customerName=${customerName}
            &address=${address}&noteTaiSan=${noteTaiSan}&status=${status}&debt=${debt}&userName=${userName}&taiSan=${taiSan}
            &dongtungay=${dongtungay}&dongdenngay=${dongdenngay}&count=${pageIndex}`,
      {},
    ),
};

export default xuatExcelApi;
